// extracted by mini-css-extract-plugin
module.exports = {"Permission":"style_Permission__2EoVV","absent_btn":"style_absent_btn__3ORkg"};